import PropTypes from 'prop-types';
import React from 'react';

class TooltipHeader extends React.Component {
  static propTypes = {
    label: PropTypes.string,
    onClose: PropTypes.func
  }

  render() {
    return (
      <div className='tooltip__header'>
        <span className='tooltip__header__label'>{ this.props.label }</span>
        <div className='tooltip__header__actions-container'>
          { this._renderCloseButton() }
        </div>
      </div>
    );
  }

  // private

  _renderCloseButton() {
    let element = null;

    if (this.props.onClose) {
      element = <i className='fa fa-times-circle tooltip__header__close-button' onClick={ this.props.onClose } />;
    }

    return element;
  }
}

export default TooltipHeader;



// WEBPACK FOOTER //
// ./app/components/shared/tooltip/_TooltipHeader.jsx